module.exports = __webpack_public_path__ + "img/AG.974e049a.svg";